import { NgModule } from "@angular/core";
import { NumberInputDirective } from "./number-input/number-input.directive";

@NgModule({
  declarations: [
    NumberInputDirective,
  ],
  exports: [
    NumberInputDirective,
  ],
  imports: [],
})
export class DirectivesModule { }



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts